// extracted by mini-css-extract-plugin
export default {"EditorDropzone":"EditorDropzone__xCL3EdcfpZOF"};